window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.SplashScreen = function() {
	this.initialize(img.SplashAssets_SplashScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.startDisabled = function() {
	this.initialize(img.SplashAssets_startDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,308,62);


(lib.startOver = function() {
	this.initialize(img.SplashAssets_startOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,308,62);


(lib.startUp = function() {
	this.initialize(img.SplashAssets_startUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,308,62);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.LoadingIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.loadingDotsTextField = new cjs.Text("...", "bold 22px 'Work Sans'", "#324141");
	this.loadingDotsTextField.name = "loadingDotsTextField";
	this.loadingDotsTextField.textAlign = "center";
	this.loadingDotsTextField.lineHeight = 27;
	this.loadingDotsTextField.lineWidth = 20;
	this.loadingDotsTextField.parent = this;
	this.loadingDotsTextField.setTransform(114.65,2.8);
ranj.TextOffsetFixer.fix(this.loadingDotsTextField);

	this.loadingTextField = new cjs.Text("Loading", "bold 22px 'Work Sans'", "#324141");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "right";
	this.loadingTextField.lineHeight = 27;
	this.loadingTextField.lineWidth = 99;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(100.85,2.8);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FAF5F0").s().p("ArXCmIAAlLIWvAAIAAFLg");
	this.shape.setTransform(72.75,16.625);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.loadingTextField},{t:this.loadingDotsTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingIndicator, new cjs.Rectangle(0,0,145.5,33.3), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.PlaceholderButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 195;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-30.3,-15.15);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 195;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-30.3,-15.15);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 195;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-30.3,-15.15);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Work Sans'", "#324141");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 195;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-30.3,-15.15);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_4
	this.instance = new lib.startUp();
	this.instance.setTransform(-150,-31);

	this.instance_1 = new lib.startOver();
	this.instance_1.setTransform(-152,-32);

	this.instance_2 = new lib.startDisabled();
	this.instance_2.setTransform(-152,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-152,-32,310,63);


(lib.LoadingBarBar2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FAF5F0").s().p("A7zBBIAAiBMA3nAAAIAACBg");
	this.shape.setTransform(178,6.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar2, new cjs.Rectangle(0,0,356,13), null);


(lib.LoadingBarBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E6CAAC").s().p("A7zBBIAAiBMA3nAAAIAACBg");
	this.shape.setTransform(178,6.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBarBar, new cjs.Rectangle(0,0,356,13), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// LoadingBarBar copy
	this.instance = new lib.LoadingBarBar2();
	this.instance.setTransform(721.3,9.95,0.0177,1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(55).to({_off:false},0).to({regX:0.1,scaleX:1.7432,x:721.25,y:10},44).wait(1));

	// LoadingBarBar
	this.instance_1 = new lib.LoadingBarBar();
	this.instance_1.setTransform(3,10,0.0227,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.937,x:2.95,y:9.95},55).to({scaleX:3.7603,x:3,y:10},44).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3,10,1338.7,13);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startButton
	this.startButton = new lib.PlaceholderButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(-0.5,332.6,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

	// Layer_7
	this.loadingIndicator = new lib.LoadingIndicator();
	this.loadingIndicator.name = "loadingIndicator";
	this.loadingIndicator.setTransform(-635.9,183.85,1,1,0,0,0,72.8,16.6);

	this.timeline.addTween(cjs.Tween.get(this.loadingIndicator).wait(1));

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-514.8,119.1,1,1,0,0,0,157.5,12.2);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// background
	this.instance = new lib.SplashScreen();
	this.instance.setTransform(-960,-540);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


// stage content:
(lib.SplashAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-0.5,-0.5,961,541);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/SplashScreen.png", id:"SplashAssets_SplashScreen", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/startDisabled.png", id:"SplashAssets_startDisabled", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/startOver.png", id:"SplashAssets_startOver", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/startUp.png", id:"SplashAssets_startUp", bundle:"SplashAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.SplashAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.SplashAssets;